import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IsActiveMatchOptions, RouterLink, RouterLinkActive } from '@angular/router';

import { IconModule } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [RouterLink, RouterLinkActive, IconModule, TranslateModule],
  selector: 'pp-routing-item',
  templateUrl: './routing-item.component.html',
  styleUrl: './routing-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoutingItemComponent {
  readonly link = input<string | string[]>();
  readonly iconName = input<string>();
  readonly i18nKey = input<string>();
  readonly exactRoute = input(false, { transform: booleanAttribute });

  get activeOptions(): { exact: boolean } | IsActiveMatchOptions {
    return this.exactRoute()
      ? {
          paths: 'exact',
          matrixParams: 'exact',
          queryParams: 'ignored',
          fragment: 'ignored',
        }
      : { exact: false };
  }
}
